import { Link } from '@tanstack/react-router';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import paths from 'src/paths';

const NotFoundPage = () => {
  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      p={3}
    >
      <MDTypography variant="h1" fontWeight="bold" mb={2}>
        404
      </MDTypography>
      <MDTypography variant="h4" mb={4}>
        Page Not Found
      </MDTypography>
      <MDTypography variant="body1" color="text" mb={4}>
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </MDTypography>
      <Link to={paths.root}>
        <MDTypography color="info" fontWeight="medium">
          Return to Home
        </MDTypography>
      </Link>
    </MDBox>
  );
};

export default NotFoundPage;
